import { render, staticRenderFns } from "./howDownLoadApp.vue?vue&type=template&id=db5df5f8&scoped=true&"
import script from "./howDownLoadApp.vue?vue&type=script&lang=js&"
export * from "./howDownLoadApp.vue?vue&type=script&lang=js&"
import style0 from "./howDownLoadApp.vue?vue&type=style&index=0&id=db5df5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5df5f8",
  null
  
)

export default component.exports